import * as React from "react";
import Backdrop, { backdropClasses } from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import {
  Rating,
  Stack,
  Tooltip,
  TextareaAutosize,
  tooltipClasses,
} from "@mui/material";
import { borderRadius, color, styled } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import { postRatings } from "../../redux/Slice/carSlice";
import { useState, useEffect } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "12px",
  boxShadow: 24,
  p: 4,
};

const StyledTextarea = styled(TextareaAutosize)(
  ({ theme }) => `
    box-sizing: border-box;
    width: 320px;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: ${theme.palette.mode === "dark" ? "#DAECFF" : "#1C2025"};
    background: ${theme.palette.mode === "dark" ? "#003A75" : "#fff"};
    border: 1px solid ${theme.palette.mode === "dark" ? "#434D5B" : "#E5EAF2"};
    box-shadow: 0px 2px 2px ${
      theme.palette.mode === "dark" ? "#303740" : "#F3F6F9"
    };
    
    &:hover {
      border-color:#008080;
    }
    
    &:focus {
      border-color:#008080;
    }
    
    &:focus-visible {
      outline: 0;
    }
  `
);
const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip} `]: {
    backgroundColor: "#00808087",
    color: "#FFF",
    // boxShadow: theme.shadows[1],
    fontSize: 11,
  },
  "& .MuiTooltip-arrow": {
    color: "#008080cc",
  },
}));

export default function RatingModal({
  isRating,
  isHandleClose,
  carId,
  bookingId,
}) {
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const [open, setOpen] = useState(true);
  const [rating, setRating] = useState(2.5);
  const [description, setDescription] = useState("");
  const dispatch = useDispatch();

  const ratingHandler = () => {
    dispatch(
      postRatings({
        carId,
        userId: userDetail?.data?._id,
        bookingId,
        rating,
        description,
      })
    );
    setDescription("");
    setRating(null);
    isHandleClose();
  };

  const handleRatingChange = (event, newRating) => {
    setRating(newRating);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };
  const cancleHandler = () => {
    setDescription("");
    setRating(null);
    isHandleClose();
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={isRating}
        onClose={isHandleClose}
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={isRating}>
          <Box sx={style}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              <Stack spacing={1}>
                <LightTooltip className="rounded shadow" title="Rate us" arrow>
                  <Rating
                    onChange={handleRatingChange}
                    name="half-rating"
                    value={rating}
                    precision={0.5}
                  />
                </LightTooltip>
              </Stack>
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              <StyledTextarea
                onChange={handleDescriptionChange}
                value={description}
                aria-label="minimum height"
                minRows={4}
              />
            </Typography>
            <Typography
              id="transition-modal-description"
              sx={{ mt: 2 }}
              className="d-flex justify-content-around"
            >
              <button
                className="fs18 pointor driver-detail-btn  border-0 "
                onClick={ratingHandler}
              >
                Submit
              </button>
              <button className="btn btn-secondary" onClick={cancleHandler}>
                Cancel
              </button>
            </Typography>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
